// extracted by mini-css-extract-plugin
module.exports = {"rowCover":"Row_rowCover__Tkpey","img":"Row_img__20rLb","list":"Row_list__UPjMU","listLinks":"Row_listLinks__1j6E0"};